import storageManager from "modules/storage-manager";

const getAccountNo = (): number => {
    const userData = storageManager.user.get();
    const accountNo = userData?.accountNo;

    return accountNo;
}

export default getAccountNo;